import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@follosoft/react-components';
import type { AddPaymentMethodPayload, CustomerPaymentMethod } from '../types';

export function useStorePaymentMethodService(contractId: string | number | undefined) {
  return useMutation<CustomerPaymentMethod, Error, AddPaymentMethodPayload>({
    mutationFn: async (payload) => {
      const res = await axiosInstance().post(
        `/customer/contracts/${contractId}/payment-methods`,
        payload
      );
      return res.data?.data ?? res.data;
    },
  });
}
